import api from "./apiClient.js";

const endpoint = "settings";

export const getAllSettings = () => {
	return api.get(endpoint);
};

export const getSettingByKey = (key) => {
	return api.get(`${endpoint}/${key}`);
};

export const setSetting = (key, value) => {
	return api.put(`${endpoint}/${key}`, { value });
};
